import React from 'react'

function CancelationPolicy() {
  return (
    <div> <svg
    className="w-[20px]"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5355 12.4645C22.4881 14.4171 22.4881 17.5829 20.5355 19.5355C18.5829 21.4882 15.4171 21.4882 13.4644 19.5355C11.5118 17.5829 11.5118 14.4171 13.4644 12.4645C15.4171 10.5118 18.5829 10.5118 20.5355 12.4645"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.866 5.495C9.863 5.495 9.861 5.497 9.861 5.5C9.861 5.503 9.863 5.505 9.866 5.505C9.869 5.505 9.871 5.503 9.871 5.5C9.871 5.497 9.869 5.495 9.866 5.495"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.327 5.495C7.324 5.495 7.322 5.497 7.322 5.5C7.322 5.503 7.324 5.505 7.327 5.505C7.33 5.505 7.332 5.503 7.332 5.5C7.332 5.497 7.33 5.495 7.327 5.495"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.77899 5.49012C4.77599 5.49012 4.77399 5.49212 4.77399 5.49512C4.77399 5.49812 4.77599 5.50012 4.77899 5.50012C4.78199 5.50012 4.78399 5.49812 4.78399 5.49512C4.78399 5.49212 4.78199 5.49012 4.77899 5.49012"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 8H19"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 11.417V5C19 3.895 18.105 3 17 3H4C2.895 3 2 3.895 2 5V16C2 17.105 2.895 18 4 18H12.418"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.41 14.5898L15.59 17.4098"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.41 17.4098L15.59 14.5898"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default CancelationPolicy